import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFile, faUpload, faEye, faChartColumn } from "@fortawesome/free-solid-svg-icons";
import Input from "../../Components/Input/Input.jsx";
import { ToastContainer, toast } from "react-toastify";
import Logo from "../../Images/NucleusTeq Logo.png";
import "./Dashboard.css";
import Card from "../../Components/Cards/Card";
import Navbar from "../../Components/Navbar/Navbar.jsx";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteCandidateResume,
  getAllProfiles,
  getAllProfilesWithPagination,
  getCandidateProfileById,
  getUserByRole,
  saveCandidateName,
  saveResumeTitle,
  uploadResume,
} from "../../Api/apiService.js";
import { logout } from "../../Api/apiService";
import { logoutUser } from "../../Redux/Authentication/AuthenticationAction";
import UploadEmployee from "./UploadEmployee.jsx";
import LayoutHOC from "../../Components/Hoc/ResumeHoc.jsx";
import ContainerWrapper from "../../Components/ContainerWrapper/container-wrapper.jsx";
import { Button, Col, Modal, Row, Tabs } from "antd";
import CustomizeButton from "../../Components/Button/Customize-Button.jsx";
import CustomTab from "../../Components/CustomTab/CustomTab.jsx";
import CommonTable from "../../Components/Table/Table.jsx";
import ModalNew from "../../Components/Modal/modal-new.jsx";
import CustomSelector from "../../Components/Input/Custom-Selector.jsx";
import InputWrapper from "../../Components/Input/Input-Wrapper.jsx";
import CustomInput from "../../Components/Input/Custom-Input.jsx";
import hamburger from "../../Images/icons/hamburger-icon.svg";
import CustomPopover from "../../Components/CustomPopover/Custom-popover.jsx";
import searchIconsvg from "../../Images/icons/Search-Icon.svg";
import "./../../Components/Navbar/Navbar.css";
import LottieIcon from "../../Components/LottieIcon/LottieIcon.jsx";
import RegisterationModal from "./components/register-modal.jsx";
import html2pdf from "html2pdf.js";
import PizZip from "pizzip";
import Docxtemplater from "docxtemplater";
import { saveAs } from "file-saver";
import downloadIcon from "../../Images/icons/downloadIcon.svg";
import viewIcon from "../../Images/icons/Eye.svg";
import editIcon from "../../Images/icons/Edit.svg";
import deleteIcon from "../../Images/icons/Delete.svg"
function DashboardHr() {
  const [titleModal, setTitleModal] = useState(false);
  const [registerModal, setRegisterModal] = useState(false);
  const [selectedCreateRole, setSelectedCreateRole] = useState(null);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  console.log(selectedEmployee, "selected employee");
  const [searchQuery, setSearchQuery] = useState("");
  const [allEmployees, setAllEmployees] = useState([]);
  const [resumeTitle, setResumeTitle] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [uploadModal, setUploadModal] = useState(false);
  const [role, setRole] = useState("");
  const [candidateName, setCandidateName] = useState("");
  const [selectedEmployeeId, setSelectedEmployeeId] = useState(null);
  const [activeTab, setActiveTab] = useState("1");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [visiblePopover, setVisiblePopover] = useState(null);
  const [profiles, setProfiles] = useState([]);
  const [showLoader, setShowLoader] = useState(false);
  const [hoveredButton, setHoveredButton] = useState(null);
  const [candidateEmail, setCandidateEmail] = useState("");
  const [employeeResumeUpload, setEmployeeResumeUpload] = useState(false);
  const [employeeresumeTitle, setEmployeeresumeTitle] = useState(false);
  const [showDeleteResumeModal, setShowDeleteResumeModal] = useState(false);
  const [deletedProfileId, setDeletedProfileId] = useState(null);
  const [isInputHovered, setIsInputHovered] = useState(false);
  const [pagination, setPagination] = useState({
    total: 0,
    per_page: 10,
    current_page: 0, // Start from 0 to match the backend
    total_pages: 0,
  });

  const [emppagination, setempPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });

  const [allProfiles, setAllProfiles] = useState([]);
  const [isResumeModalVisible, setIsResumeModalVisible] = useState(false);
  const [selectedResumeId, setSelectedResumeId] = useState(null);
  const [resume, setResume] = useState(null);

  const getProfilesWithPagination = async (page, size, searchQuery = "") => {
    try {
      setShowLoader(true);
      const response = await getAllProfilesWithPagination(page, size, searchQuery);
      if (response?.status === 200 || response?.status === 201) {
        const activeProfiles = response.data.data.filter((profile) => !profile.isDeleted);
        setProfiles(activeProfiles);
        setPagination({
          total: response.data.pagination.total,
          per_page: response.data.pagination.per_page,
          current_page: response.data.pagination.current_page,
          total_pages: response.data.pagination.total_pages,
        });
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Something went wrong.", {
        autoClose: 2000,
      });
    } finally {
      setShowLoader(false);
    }
  };
  const isAuthenticated = useSelector((state) => state.auth);

  const entries = [
    { key: "1", label: "Employees" },
    { key: "2", label: "Candidates" },
  ];

  const roleList = [
    { label: "Employee", value: "EMPLOYEE" },
    { label: "Candidate", value: "CANDIDATE" },
  ];

  const employeeList = [
    {
      label: "Employee",
      value: "ROLE_EMPLOYEE",
    },
    {
      label: "HR",
      value: "ROLE_HR",
    },
  ];

  const confirmDelete = async () => {
    if (!deletedProfileId) return;
    try {
      console.log(deletedProfileId);
      const deleteResponse = await deleteCandidateResume(deletedProfileId);
      if (deleteResponse.data.isDeleted) {
        setProfiles((prevProfiles) => prevProfiles.filter((profile) => profile.id !== deletedProfileId));
        setShowDeleteResumeModal(false);
        toast.success("Resume deleted successfully!", { autoClose: 1500 });
      }
    } catch (error) {
      toast.error("Failed to delete resume.");
    }
  };

  const handleViewClick = async (userId) => {
    setSelectedResumeId(userId);
    setIsResumeModalVisible(true);

    try {
      const response = await getCandidateProfileById(userId);
      setResume(response.data);
      console.log(response.data, "this is response of the data resume");
    } catch (error) {
      console.error("Error fetching resume:", error);
    }
  };
  const sortedExperience = resume?.profileData?.professionalExperience?.sort((a, b) => new Date(b.endDate) - new Date(a.endDate)) || [];

  const sortedEducation =
    resume?.profileData?.education
      ?.map((edu) => ({
        ...edu,

        duration: edu.duration?.trim().endsWith("-") ? edu.duration.replace(/-\s*$/, "") : edu.duration,
      }))
      .sort((a, b) => {
        const endDateA = a.duration?.split(" - ")[1] || a.duration;
        const endDateB = b.duration?.split(" - ")[1] || b.duration;

        return new Date(endDateB) - new Date(endDateA);
      }) || [];
  const formatExperienceDetails = (details) => {
    if (!details) return null;

    // First split by newlines
    const lines = details.split("\n");
    const allPoints = [];

    lines.forEach((line) => {
      let trimmedLine = line.trim();

      // Remove bullet point if it exists at the start
      if (trimmedLine.startsWith("•")) {
        trimmedLine = trimmedLine.substring(1).trim();
      }

      // Skip empty lines
      if (!trimmedLine) return;

      // Split by full stop and filter out empty strings
      const sentences = trimmedLine
        .split(".")
        .map((sentence) => sentence.trim())
        .filter((sentence) => sentence.length > 0);

      // Add each sentence as a separate point
      sentences.forEach((sentence) => {
        allPoints.push(sentence);
      });
    });

    return allPoints.map((point, index) => <li key={index}>{point}</li>);
  };
  const formatDate = (date) => {
    if (!date) return "";

    if (date.toLowerCase() === "present" || date.toLowerCase() === "current" || date.toLowerCase() === "now" || date.toLowerCase() === "till date") {
      return "Present";
    }

    const monthYearRegex = /^([a-zA-Z]{3,9})['’]?(\d{2}|\d{4})$/; // Matches formats like "Jan'22" or "Jan22"
    const match = date.match(monthYearRegex);

    if (match) {
      const month = match[1]; // Extract the month (e.g., "Jan")
      const year = `20${match[2]}`; // Extract the year (e.g., "22" -> "2022")
      const monthIndex = new Date(`${month} 1, ${year}`).getMonth(); // Get the month index (0-11)
      const options = { year: "numeric", month: "2-digit" };
      return new Date(year, monthIndex, 1).toLocaleDateString("en-GB", options).replace(/\//g, "/");
    }

    const numericMonthYearRegex = /^(\d{1,2})\/(\d{4})$/;
    const numericMatch = date.match(numericMonthYearRegex);

    if (numericMatch) {
      const month = numericMatch[1]; // Extract the month
      const year = numericMatch[2]; // Extract the year
      const options = { year: "numeric", month: "2-digit" };
      return new Date(year, month - 1, 1).toLocaleDateString("en-GB", options).replace(/\//g, "/");
    }

    const isoDateRegex = /^(\d{4})-(\d{2})-(\d{2})$/;
    const isoMatch = date.match(isoDateRegex);
    if (isoMatch) {
      const year = parseInt(isoMatch[1], 10);
      const month = parseInt(isoMatch[2], 10) - 1;
      const day = parseInt(isoMatch[3], 10);
      return new Date(year, month, day).toLocaleDateString("en-GB", {
        year: "numeric",
        month: "short",
        day: "2-digit",
      });
    }

    const usDateRegex = /^(\d{2})-(\d{2})-(\d{4})$/;
    const usMatch = date.match(usDateRegex);
    if (usMatch) {
      const month = parseInt(usMatch[1], 10) - 1;
      const day = parseInt(usMatch[2], 10);
      const year = parseInt(usMatch[3], 10);
      return new Date(year, month, day).toLocaleDateString("en-GB", {
        year: "numeric",
        month: "short",
        day: "2-digit",
      });
    }

    const euDateRegex = /^(\d{2})-(\d{2})-(\d{4})$/;
    const euMatch = date.match(euDateRegex);
    if (euMatch) {
      const day = parseInt(euMatch[1], 10);
      const month = parseInt(euMatch[2], 10) - 1;
      const year = parseInt(euMatch[3], 10);
      return new Date(year, month, day).toLocaleDateString("en-GB", {
        year: "numeric",
        month: "short",
        day: "2-digit",
      });
    }

    const fullMonthYearRegex = /^([a-zA-Z]{3,9}) (\d{4})$/;
    const fullMonthYearMatch = date.match(fullMonthYearRegex);
    if (fullMonthYearMatch) {
      const month = fullMonthYearMatch[1];
      const year = parseInt(fullMonthYearMatch[2], 10);
      const monthIndex = new Date(`${month} 1, ${year}`).getMonth();
      return new Date(year, monthIndex, 1).toLocaleDateString("en-GB", {
        year: "numeric",
        month: "short",
      });
    }

    return date;
  };

  useEffect(() => {
    if (isAuthenticated.token === "") {
      handleLogout();
    }
  }, [isAuthenticated, navigate]);

  const handleEdit = (userId) => {
    navigate(`/personalInfo/?candidateProfileId=${userId}`);
    window.localStorage.removeItem("profileId");
    window.localStorage.setItem("profileId", userId);
    window.localStorage.setItem("selectedRole", "candidate");
  };
  const handleEmployeeAction = (record) => {
    console.log("Taking action for employee:", record);
    console.log("Full profile data:", record.profileData);

    console.log("Employee Profile ID:", record.userId);
    window.localStorage.removeItem("selectedRole");
    window.localStorage.setItem("selectedRole", "employee");
    navigate(`/dashboardHR/employee/${record.userId}`, {
      state: { name: record.name },
    });
  };
  useEffect(() => {
    if (activeTab === "1") {
      getProfiles(1, 10, searchQuery); // Load all employee profiles (non-paginated)
    } else if (activeTab === "2") {
      getProfilesWithPagination(pagination.current_page, pagination.per_page, searchQuery);
    }
  }, [pagination.current_page, searchQuery, activeTab]);

  const popoverContent = (record) => (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "10px",
        width: "200px",
      }}
    >
      <Button onClick={() => handleViewClick(record.id)} className="navbar-item">
        <span>View</span>

        <img src={hamburger} alt="menu" />
      </Button>
      <Button
        onClick={() => handleEdit(record.id)}
        style={{
          width: "11rem",
        }}
        className="navbar-item"
      >
        <span>Edit</span>
        <img src={hamburger} alt="menu" />
      </Button>
      <Button
        style={{
          width: "11rem",
        }}
        className="navbar-item"
      >
        <span>Delete</span>
        <img src={hamburger} alt="menu" />
      </Button>
    </div>
  );

  const employeeColumns = [
    {
      title: "S.No",
      dataIndex: "serialNo",
      key: "serialNo",
      width: 80,
      render: (_, __, index) => (emppagination.current - 1) * emppagination.pageSize + index + 1,
    },
    {
      title: "Employee Name",
      dataIndex: "name", // Changed from profileName to name
      key: "name",
      width: 200,
    },
    {
      title: "Employee ID",
      dataIndex: "employeeId",
      key: "employeeId",
      width: 150,
    },
    {
      title: "Resumes",
      key: "actions",
      width: 120,
      render: (_, record) => (
        <span
          style={{
            color: "#E74860",
            cursor: "pointer",
            fontSize: "14px",
            fontWeight: "400",
          }}
          onClick={(e) => {
            e.stopPropagation();
            handleEmployeeAction(record);
          }}
        >
          View Resumes
        </span>
      ),
    },
  ];

  const transformedCandidateData = profiles.map((profile, index) => ({
    id: profile.id,
    key: profile.id, // Required for Ant Design table
    serialNo: pagination.current_page * pagination.per_page + index + 1, // Calculate serial number based on pagination
    resumeTitle: profile.resumeTitle || `Resume ${profile.id}`, // Use name as resume title or fallback
    name: profile.name || "N/A",
    email: profile.email || "N/A",
    contactNo: profile.contactNo || "N/A",
    objective: profile.objective || "N/A",
    createdAt: profile.createdAt ? new Date(profile.createdAt).toLocaleDateString() : "N/A",
    profileData: profile.profileData, // Keep the full profile data for actions
  }));

  const candidateColumns = [
    {
      title: "S.No",
      dataIndex: "serialNo",
      key: "serialNo",
    },
    {
      title: "Resume Title",
      dataIndex: "resumeTitle",
      key: "resumeTitle",
    },

    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },

    {
      title: "Actions",
      key: "actions",
      render: (_, record) => {
        // Define popoverContent INSIDE the render function where record is available

        const popoverContent = (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "10px",
          }}
        >
          <Button
            className="navbar-item"
            onClick={() => {
              handleViewClick(record.id);
              setVisiblePopover(null);
            }}
            onMouseEnter={() => setHoveredButton("view")}
            onMouseLeave={() => setHoveredButton(null)}
          >
            <span>View</span>
            {hoveredButton === "view" ? (
              <LottieIcon name="viewIcon" size={28} shouldPlay={true} />
            ) : (
              <img src={viewIcon} alt="view-icon" height={28} />
            )}
          </Button>

          <Button
            onClick={() => {
              handleEdit(record.id);
              setVisiblePopover(null);
            }}
            style={{ width: "11rem" }}
            className="navbar-item"
            onMouseEnter={() => setHoveredButton("edit")}
            onMouseLeave={() => setHoveredButton(null)}
          >
            <span>Edit</span>
            {hoveredButton === "edit" ? (
              <LottieIcon name="editIcon" size={24} shouldPlay={true} />
            ) : (
              <img src={editIcon} alt="edit-icon" height={28} />
            )}
          </Button>

          <Button
            onClick={() => {
              setVisiblePopover(null);
              setDeletedProfileId(record.id);
              setShowDeleteResumeModal(true);
            }}
            style={{ width: "11rem" }}
            className="navbar-item"
            onMouseEnter={() => setHoveredButton("delete")}
            onMouseLeave={() => setHoveredButton(null)}
          >
            <span>Delete</span>
            {hoveredButton === "delete" ? (
              <LottieIcon name="trashIcon" size={24} shouldPlay={true} />
            ) : (
              <img src={deleteIcon} alt="delete-icon" height={28} />
            )}
          </Button>
        </div>
      );


        return (
          <CustomPopover
            content={popoverContent}
            placement="bottomRight"
            trigger="click"
            open={visiblePopover === record.id}
            onOpenChange={(open) => setVisiblePopover(open ? record.id : null)}
          >
            <span
              style={{
                color: "#E74860",
                cursor: "pointer",
                fontSize: "14px",
                fontWeight: "400",
              }}
              onClick={(e) => {
                e.stopPropagation();
              }}
            >
              Take Actions
            </span>
          </CustomPopover>
        );
      },
    },
  ];

  const handleTableChange = ({ current, pageSize }) => {
    console.log("Pagination changed:", { current, pageSize });
    setPagination((prev) => ({
      ...prev,
      current_page: current - 1, // Convert to 0-based indexing for backend
      per_page: pageSize,
    }));
  };

  const tablePagination = {
    current: pagination.current_page + 1,
    pageSize: pagination.per_page,
    total: pagination.total,
    showSizeChanger: true,
    showQuickJumper: true,
    pageSizeOptions: ["5", "10", "20", "50"],
    showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
  };

  const handleResumeClick = () => {
    setRole("");
    setTitleModal(true);
  };

  const handleLogout = () => {
    toast.success("Logged out successfully.", {
      autoClose: 2000,
    });
    setTimeout(() => {
      logout();
      dispatch(logoutUser());
      navigate("/");
      window.location.reload();
    }, 3000);
  };

  const handleUploadResume = async (e) => {
    e.preventDefault();
    const selectedFile = e.target.files[0];

    if (!selectedFile) {
      toast.error("Please select a file to upload.", {
        autoClose: 2000,
      });
      return;
    }
    const profileId = window.localStorage.getItem("profileId");
    const formData = new FormData();
    formData.append("resume", selectedFile);
    if (selectedEmployeeId) {
      formData.append("userId", profileId);
      formData.append("role", "ROLE_EMPLOYEE");
    }

    try {
      const response = await uploadResume(formData);
      if (response?.status === 200 || response?.status === 201) {
        toast.success(response?.data?.message || "PDF Resume uploaded successfully!", {
          autoClose: 2000,
        });

        closeuploadModal();
        window.localStorage.removeItem("selectedEmployeeId");
        window.localStorage.removeItem("selectedRole");
        window.localStorage.removeItem("profileId");
        selectedEmployeeId ? navigate("/dashboardHr") : navigate("/dashboardHr");
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Something went wrong.", {
        autoClose: 2000,
      });
    }
  };

  const onCloseTitleModal = () => {
    setTitleModal(false);
  };

  const closeModal = () => {
    setOpenModal(false);
  };

  const closeuploadModal = () => {
    setUploadModal(false);
  };

  const employeeOptions = allEmployees.map((employee) => ({
    label: employee.name,
    value: employee.userId,
  }));
  useEffect(() => {
    if (selectedCreateRole === "EMPLOYEE") {
      fetchUserByRole();
    } else {
      setAllEmployees([]);
      setSelectedEmployee(null);
    }
  }, [selectedCreateRole]);

  const handleTitleSave = async () => {
    if (selectedCreateRole === "EMPLOYEE") {
      try {
        const response = await saveResumeTitle(resumeTitle, selectedEmployee);
        if (response?.status === 200 || response?.status === 201) {
          toast.success(response?.data?.message || "Resume Title Saved", {
            autoClose: 2000,
          });

          window.localStorage.removeItem("profileId");
          window.localStorage.setItem("profileId", response.data.id);
          window.localStorage.setItem("selectedEmployeeId", selectedEmployee);
          window.localStorage.setItem("selectedRole", "employee");

          setTimeout(() => {
            navigate("/personalInfo");
          }, 2000);
        }
      } catch (error) {
        toast.error(error?.response?.data?.message || "Something went wrong.", {
          autoClose: 2000,
        });
      }
    } else if (selectedCreateRole === "CANDIDATE") {
      if (!candidateName || candidateName.trim() === "") {
        toast.warning("Please provide candidate name", {
          autoClose: 2000,
        });
        return; // Stop execution if validation fails
      }
      try {
        const response = await saveCandidateName(candidateName);
        if (response?.status === 200 || response?.status === 201) {
          toast.success(response?.data?.message || "Candidate Name Saved", {
            autoClose: 2000,
          });
          setTimeout(() => {
            navigate(`/personalInfo?candidateProfileId=${response.data.id}`);
          }, 2000);
        }
        window.localStorage.setItem("profileId", response.data.id);
        window.localStorage.setItem("selectedRole", "candidate");
      } catch (error) {
        toast.error(error?.response?.data?.message || "Something went wrong.", {
          autoClose: 2000,
        });
      }
    }
  };

  const handleUploadResumee = async (e) => {
    e.preventDefault();
    const selectedFile = e.target.files[0];
    closeuploadModal();

    if (!selectedFile) {
      toast.error("Please select a file to upload.", {
        autoClose: 2000,
      });
      return;
    }
    const profileId = window.localStorage.getItem("profileId");
    const formData = new FormData();
    formData.append("resume", selectedFile);
    formData.append("userId", profileId);
    formData.append("role", "ROLE_EMPLOYEE");
    console.log("this is working");
    console.log(formData.get("role"));
    console.log(formData.get("userId"));

    try {
      const response = await uploadResume(formData);
      if (response?.status === 200 || response?.status === 201) {
        toast.success(response?.data?.message || "PDF Resume uploaded successfully!", {
          autoClose: 2000,
        });
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Something went wrong.", {
        autoClose: 2000,
      });
    }
  };

  // const getProfiles = async () => {
  //   try {
  //     setShowLoader(true);
  //     const response = await getAllProfiles();
  //     if (response?.status === 200 || response?.status === 201) {
  //       const activeProfiles = response.data.filter((profile) => !profile.isDeleted && !profile.deleted);
  //       setAllProfiles(activeProfiles);
  //     }
  //   } catch (error) {
  //     toast.error(error?.response?.data?.message || "Something went wrong.", {
  //       autoClose: 2000,
  //     });
  //   } finally {
  //     setShowLoader(false);
  //   }
  // };
  const handleRowClick = (record) => {
    console.log("Row clicked:", record);
  };
  const getProfiles = async (page = 1, pageSize = 10, searchText = "") => {
    try {
      setShowLoader(true);
      const response = await getAllProfiles(page, pageSize, searchText);
      if (response?.status === 200 || response?.status === 201) {
        // Set profiles from data array
        setAllProfiles(response.data.data);

        // Update pagination with correct values from API response
        setempPagination({
          current: response.data.pagination.current_page,
          pageSize: response.data.pagination.per_page,
          total: response.data.pagination.total,
        });
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Something went wrong.", {
        autoClose: 2000,
      });
    } finally {
      setShowLoader(false);
    }
  };

  const handleEmployee = () => {
    window.localStorage.setItem("selectedRole", "employee");
    navigate("/employeeResumeList");
  };

  const handleCandidate = () => {
    window.localStorage.setItem("selectedRole", "candidate");
    navigate("/candidateResumeList");
  };

  const handleUploadCandidate = () => {
    document.getElementById("resume").click();
  };

  const handleUploadEmployee = () => {
    setRole("employee");
    fetchUserByRole();
  };

  const handleChange = (event) => {
    const selectedRole = event.target.value;
    setRole(selectedRole);

    if (selectedRole === "employee") {
      fetchUserByRole();
    }
  };

  const handleEmployeeSelect = (event) => {
    const selectedId = event.target.value;
    console.log(selectedId);
    setSelectedEmployeeId(selectedId);

    window.localStorage.setItem("selectedEmployeeId", selectedId);
  };

  const fetchUserByRole = async () => {
    try {
      const response = await getUserByRole();
      setAllEmployees(response.data);
    } catch (error) {
      toast.error(error?.response?.data?.message || "Something went wrong.", {
        autoClose: 2000,
      });
    }
  };

  const handleDownloadPDF = (profile) => {
    const element = document.getElementById("resume-content");
    const opt = {
      margin: [10, 0, 23, 0],
      filename: `${profile.firstName || "Name"}_${profile.lastName}_Resume.pdf`,
      image: { type: "jpeg", quality: 1 },
      html2canvas: { scale: 2, scrollX: 0, scrollY: 0, useCORS: true },
      jsPDF: { unit: "pt", format: "a4", orientation: "portrait" },
      pagebreak: {
        mode: ["css", "legacy"],
        avoid: ".section-title", 
      },
    };

    html2pdf().set(opt).from(element).save();
  };

  const handleDownloadWord = (profile) => {
    fetch("/resume_template.docx")
      .then((response) => {
        if (!response.ok) {
          throw new Error("Failed to load the Word template file.");
        }
        return response.arrayBuffer();
      })
      .then((content) => {
        // Use PizZip to load the content
        const zip = new PizZip(content);
        const doc = new Docxtemplater(zip, {
          paragraphLoop: true,
          linebreaks: true,
        });

        doc.render({
          name: profile?.name || "Employee",
          objective: profile?.objective || "N/A",
          professionalSummary: profile?.profileData?.professionalSummary || "N/A",
          technicalSkills: profile?.profileData?.technicalSkills || [],
          professionalExperience: profile?.profileData?.professionalExperience || [],
          education: profile?.profileData?.education || [],
          certificates: profile?.profileData?.certificates || [],
        });
        const blob = doc.getZip().generate({
          type: "blob",
          mimeType: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        });

        console.log("Docxtemplater Data:", doc.getFullText());
        saveAs(blob, `${profile?.profileName || "Employee"}_Resume.docx`);
      })
      .catch((error) => {
        console.error("Error loading or generating Word template:", error);
      });
  };
  const handleSearchEnter = (e) => {
    setSearchQuery(e.target.value);
  };
  const handleUploadClick = () => {
    if (activeTab === "1") {
      setEmployeeResumeUpload(true);
      fetchUserByRole();
    } else if (activeTab === "2") {
      document.getElementById("resume-upload").click();
    }
  };
  const handleEmployeeResumeUpload = async (e) => {
    e.preventDefault();
    const selectedFile = e.target.files[0];

    if (!selectedFile) {
      toast.error("Please select a file to upload.", {
        autoClose: 2000,
      });
      return;
    }

    const profileId = window.localStorage.getItem("profileId");
    const formData = new FormData();
    formData.append("resume", selectedFile);
    formData.append("userId", profileId);
    formData.append("role", "ROLE_EMPLOYEE");

    try {
      const response = await uploadResume(formData);
      if (response?.status === 200 || response?.status === 201) {
        toast.success(response?.data?.message || "PDF Resume uploaded successfully!", {
          autoClose: 2000,
        });

        // Cleanup
        setEmployeeResumeUpload(false);
        window.localStorage.removeItem("selectedEmployee");
        window.localStorage.removeItem("selectedRole");
        window.localStorage.removeItem("profileId");

        // Reset form
        setSelectedEmployee("");
        setEmployeeresumeTitle("");

        // Navigate or refresh data
        navigate("/employeeResumeList");
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Something went wrong.", {
        autoClose: 2000,
      });
    }
  };
  const handleEmployeResumeTitle = async () => {
    if (!employeeresumeTitle || !selectedEmployee) {
      toast.error("Please select an employee and enter a resume title.", {
        autoClose: 2000,
      });
      return;
    }

    try {
      const response = await saveResumeTitle(employeeresumeTitle, selectedEmployee);
      if (response?.status === 200 || response?.status === 201) {
        const profileId = response.data.id;
        localStorage.setItem("profileId", profileId);
        localStorage.setItem("selectedRole", "employee");

        toast.success(response?.data?.message || "Resume Title Saved", {
          autoClose: 2000,
        });

        setTimeout(() => {
          document.getElementById("employee-resume-upload").click();
        }, 1000);
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Failed to save title", {
        autoClose: 2000,
      });
    }
  };
  return (
    <div className="dashboard-container-outer">
      <ContainerWrapper
        breadcrumbItems={["Dashboard HR"]}
        headerRight={
          <div onMouseEnter={() => setIsInputHovered(true)} onMouseLeave={() => setIsInputHovered(false)}>
            <CustomInput
              icon={
                isInputHovered ? (
                  <LottieIcon name="searchIcon" size={24} shouldPlay={true} />
                ) : (
                  <img src={searchIconsvg} alt="search" style={{ width: 24, height: 24 }} />
                )
              }
              style={{ width: "18rem" }}
              onPressEnter={handleSearchEnter}
              onChange={(e) => {
                setCandidateEmail(e.target.value);
              }}
              placeholder={activeTab === "1" ? "Name and Emp.ID" : "Email"}
            />
          </div>
        }
      >
        <div className="dashboard-inner-container">
          <Col>
            <Row>
              <span
                style={{
                  fontWeight: "500",
                  fontSize: "24px",
                  marginBottom: "20px",
                  color: "#464646",
                }}
              >
                Welcome to HR Portal
              </span>
            </Row>

            {/* Tabs Row */}
            <Row>
              <Col span={5}>
                <CustomTab entries={entries} onChange={(key) => setActiveTab(key)} />
              </Col>
              <Col span={19}>
                <div
                  style={{
                    display: "flex",
                    gap: "10px",
                    justifyContent: "flex-end",
                  }}
                >
                  <CustomizeButton
                    onClick={() => {
                      setRegisterModal(true);
                    }}
                    variant="primary"
                  >
                    {" "}
                    Register New Employee{" "}
                  </CustomizeButton>
                  <CustomizeButton
                    onClick={() => {
                      setTitleModal(true);
                    }}
                    variant="primary"
                  >
                    {" "}
                    Create Resume{" "}
                  </CustomizeButton>
                  <CustomizeButton variant="primary" onClick={handleUploadClick}>
                    Upload Resume
                  </CustomizeButton>

                  {/* Hidden File Input */}
                  <input id="resume-upload" type="file" accept="application/pdf" style={{ display: "none" }} onChange={handleUploadResume} />
                </div>
              </Col>
            </Row>
            <Row>
              <div
                className="table-container"
                style={{
                  width: "100%",
                }}
              >
                {activeTab === "1" && (
                  <CommonTable
                    data={allProfiles}
                    columns={employeeColumns}
                    tableTitle="Employees Table"
                    rowClickable={true}
                    settingModalDataFunction={handleRowClick}
                    showLoader={showLoader}
                    pagination={emppagination}
                    onChange={(paginationConfig) => {
                      getProfiles(paginationConfig.current, paginationConfig.pageSize);
                    }}
                  />
                )}

                {activeTab === "2" && (
                  <CommonTable
                    data={transformedCandidateData}
                    columns={candidateColumns}
                    tableTitle="Candidates Table"
                    rowClickable={true}
                    settingModalDataFunction={handleRowClick}
                    showLoader={showLoader}
                    pagination={tablePagination}
                    onChange={handleTableChange}
                  />
                )}
              </div>
            </Row>
          </Col>
        </div>

        <ModalNew title="Select Role" visible={titleModal} onClose={onCloseTitleModal}>
          <div className="selector-container">
            <div>
              <InputWrapper label="Select Role" required>
                <CustomSelector
                  value={selectedCreateRole}
                  onChange={(value) => setSelectedCreateRole(value)}
                  options={roleList}
                  className="role-selector"
                  placeholder="Select a Role"
                />
              </InputWrapper>
            </div>

            {selectedCreateRole && (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                  marginTop: "10px",
                }}
              >
                {selectedCreateRole === "EMPLOYEE" && (
                  <InputWrapper label="Select An Employee" required>
                    <CustomSelector
                      className="role-selector"
                      placeholder="Select an Employee"
                      options={employeeOptions}
                      value={selectedEmployee}
                      onChange={(value) => setSelectedEmployee(value)}
                    />
                  </InputWrapper>
                )}

                <InputWrapper label="Enter Resume Title">
                  <CustomInput
                    className="role-selector"
                    onChange={(e) => {
                      if (selectedCreateRole === "CANDIDATE") {
                        setCandidateName(e.target.value);
                      } else {
                        setResumeTitle(e.target.value);
                      }
                    }}
                    placeholder="Enter Resume Title"
                  />
                </InputWrapper>
              </div>
            )}

            <div style={{ display: "flex", gap: "10px", width: "100%", marginTop: "20px" }}>
              <CustomizeButton onClick={handleTitleSave} className="navigate-btn" variant="primary">
                {" "}
                Next{" "}
              </CustomizeButton>
              <CustomizeButton onClick={onCloseTitleModal} className="navigate-btn" variant="outlined">
                {" "}
                Cancel{" "}
              </CustomizeButton>
            </div>
          </div>
        </ModalNew>

        <RegisterationModal visible={registerModal} onClose={() => setRegisterModal(false)} employeeList={employeeList} />

        {/* <Modal
          show={titleModal}
          onClose={onCloseTitleModal}
          height={role === "employee" ? "235px" : role === "candidate" ? "170px" : "105px"}
          width="350px"
        >
          <div className="create-resume-hr">
            <div className="form-content" style={{ marginTop: "1%" }}>
              <label htmlFor="roleDropdown" className="form-field-label">
                Select Role
              </label>
              <br />
              <select
                id="roleDropdown"
                value={role}
                style={{ width: "91%" }}
                onChange={handleChange}
                className="form-field-input profile-input-field-password"
              >
                <option value="">Select role</option>
                <option value="employee">Employee</option>
                <option value="candidate">Candidate</option>
              </select>
            </div>
            <div>
              {role === "employee" ? (
                <div style={{ marginTop: "2%" }}>
                  <label htmlFor="employeeSelect" className="form-field-label">
                    Select Employee
                  </label>
                  <br />
                  <select
                    id="employeeSelect"
                    value={selectedEmployeeId || ""}
                    onChange={handleEmployeeSelect}
                    style={{ width: "91%" }}
                    className="form-field-input profile-input-field-password"
                  >
                    <option value="">Select an employee</option>
                    {allEmployees.map((employee) => (
                      <option key={employee.userId} value={employee.userId}>
                        {employee.name}
                      </option>
                    ))}
                  </select>
                  <Input
                    className="profile-input-field-password"
                    type="text"
                    label="Enter Resume Title"
                    value={resumeTitle}
                    onChange={(e) => setResumeTitle(e.target.value)}
                  />
                </div>
              ) : role === "candidate" ? (
                <>
                  <Input
                    className="profile-input-field-password"
                    type="text"
                    label="Enter Candidate Name"
                    value={candidateName}
                    onChange={(e) => setCandidateName(e.target.value)}
                  />
                </>
              ) : null}
            </div>
          </div>

          <Button className="change-btn" onClick={handleTitleSave}>
            Save & Next
          </Button>
        </Modal> */}

        <Modal show={openModal} onClose={closeModal} height="70px" width="290px">
          <label className="form-field-label" style={{ fontWeight: "bold", fontSize: "1.1rem" }}>
            View resumes for
          </label>
          <div className="view-resume-btn">
            <Button className="view-resume-buttons" onClick={handleEmployee}>
              Employee
            </Button>
            <Button className="view-resume-buttons" onClick={handleCandidate}>
              Candidate
            </Button>
          </div>
        </Modal>

        <Modal show={uploadModal} onClose={closeuploadModal} height="70px" width="290px">
          <UploadEmployee closeuploadModal={closeuploadModal} />
        </Modal>
        <Modal
          open={isResumeModalVisible}
          footer={null} // remove default footer
          onCancel={() => setIsResumeModalVisible(false)}
          width="50%"
          style={{
            padding: 0,
          }}
        >
          {resume && (
            <div className="resume-container" id="resume-content">
              <div className="logo-container">
                <img src={Logo} alt="logo" className="logo" />
              </div>
              <div className="personal-info">
                <h1>{resume?.firstName && resume?.lastName ? `${resume.firstName} ${resume.lastName}` : "Name"}</h1>
                {/* {resume.contactNo && <div className="contact">📞 {resume.contactNo}</div>}
          {resume.email && <div className="contact">✉️ {resume.email}</div>} */}
              </div>

              {resume.objective && resume.objective.trim().length > 0 && (
                <div>
                  <h2 className="section-title">Objective</h2>
                  <p className="selection-obj">{resume.objective}</p>
                </div>
              )}

              {resume?.profileData?.professionalSummary?.trim()?.length > 0 && (
                <div>
                  <h2 className="section-title">Professional Summary</h2>
                  <p className="section-para">{resume?.profileData.professionalSummary}</p>
                </div>
              )}

              {(resume?.profileData?.technicalSkills?.technology?.length > 0 ||
                resume?.profileData?.technicalSkills?.programming?.length > 0 ||
                resume?.profileData?.technicalSkills?.tools?.length > 0) && (
                <div>
                  <h2 className="section-title">Technical Skills</h2>

                  {resume?.profileData?.technicalSkills?.technology?.length > 0 && (
                    <>
                      <h3 className="sub-section-title">Technology</h3>
                      <ul className="bullet-section-tech grid-layout">
                        {resume?.profileData.technicalSkills.technology.map((tech, index) => (
                          <li key={index}>{tech}</li>
                        ))}
                      </ul>
                    </>
                  )}

                  {resume?.profileData?.technicalSkills?.programming?.length > 0 && (
                    <>
                      <h3 className="sub-section-title">Programming</h3>
                      <ul className="bullet-section-tech grid-layout">
                        {resume?.profileData.technicalSkills.programming.map((prog, index) => (
                          <li key={index}>{prog}</li>
                        ))}
                      </ul>
                    </>
                  )}

                  {resume?.profileData?.technicalSkills?.tools?.length > 0 && (
                    <>
                      <h3 className="sub-section-title">Tools</h3>
                      <ul className="bullet-section-tech">
                        {resume?.profileData.technicalSkills.tools.map((tool, index) => (
                          <li key={index}>{tool}</li>
                        ))}
                      </ul>
                    </>
                  )}
                </div>
              )}
              {sortedExperience?.length > 0 && (
                <div>
                  <h2 className="section-title">Professional Experience</h2>
                  {sortedExperience.map((experience, index) => (
                    <div key={index} className="professional-experience">
                      <h3 className="experience-heading">
                        {experience.jobTitle || "Position"} at {experience.companyName || "Company"}
                        <span className="experience-dates">
                          ({formatDate(experience.startDate)} - {formatDate(experience.endDate)})
                        </span>
                      </h3>
                      {experience.projectName?.trim()?.length > 0 && (
                        <p className="experience-project">
                          <strong>Project:</strong> {experience.projectName}
                        </p>
                      )}
                      {experience.techStack?.trim()?.length > 0 && (
                        <p className="experience-project">
                          <strong>Technologies Used:</strong> {experience.techStack}
                        </p>
                      )}
                      <ul className="bullet-section">{formatExperienceDetails(experience.details)}</ul>
                    </div>
                  ))}
                </div>
              )}

              {sortedEducation?.length > 0 && (
                <div>
                  <h2 className="section-title">Education</h2>
                  {sortedEducation.map((education, index) => (
                    <div key={index} className="education">
                      <h3 className="experience-heading">
                        {education.course || "Course"} from {education.collegeName || "Institution"}
                      </h3>
                      {education.duration && education.duration.trim().length > 0 && (
                        <p
                          className={
                            education.duration.includes("%") || education.duration.includes("CGPA") ? "experience-duration" : "experience-duration"
                          }
                        >
                          {education.duration.includes("%") || education.duration.includes("CGPA") ? (
                            <>Percentage/CGPA: {education.duration}</>
                          ) : (
                            <>Duration: {education.duration}</>
                          )}
                        </p>
                      )}
                    </div>
                  ))}
                </div>
              )}

              {resume.profileData?.certificates?.length > 0 && (
                <div>
                  <h2 className="section-title">Certificates</h2>
                  <ul className="bullet-section">
                    {resume.profileData.certificates.map((certificate, index) => (
                      <li key={index}>{certificate}</li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          )}
          {isResumeModalVisible && (
            <div className="floating-buttons">
              <CustomizeButton className="download-btn" variant="primary" onClick={() => handleDownloadPDF(resume)}>
                Download PDF
                <img src={downloadIcon} alt="download" style={{ width: "24px", marginLeft: "8px", filter: "brightness(0) invert(1)" }} />
              </CustomizeButton>
              <CustomizeButton variant="primary" onClick={() => handleDownloadWord(resume)}>
                Download Word
                <img src={downloadIcon} alt="download" style={{ width: "24px", marginLeft: "8px", filter: "brightness(0) invert(1)" }} />
              </CustomizeButton>
            </div>
          )}
        </Modal>

        <ModalNew title="Upload Resume for Employee" visible={employeeResumeUpload} onClose={() => setEmployeeResumeUpload(false)}>
          <div className="selector-container">
            <InputWrapper label="Select An Employee" required>
              <CustomSelector
                className="role-selector"
                placeholder="Select an Employee"
                options={employeeOptions}
                value={selectedEmployee}
                onChange={(value) => setSelectedEmployee(value)}
              />
            </InputWrapper>

            <InputWrapper label="Enter Resume Title">
              <CustomInput
                onChange={(e) => {
                  setEmployeeresumeTitle(e.target.value);
                }}
                className="role-selector"
                placeholder="Enter Resume Title"
              />
            </InputWrapper>
            <div style={{ display: "flex", gap: "10px", width: "100%", marginTop: "20px" }}>
              <CustomizeButton onClick={handleEmployeResumeTitle} className="navigate-btn" variant="primary">
                {" "}
                Choose a file{" "}
              </CustomizeButton>
              <CustomizeButton
                onClick={() => {
                  setEmployeeResumeUpload(false);
                }}
                className="navigate-btn"
                variant="outlined"
              >
                {" "}
                Cancel{" "}
              </CustomizeButton>
              <input
                id="employee-resume-upload"
                type="file"
                accept="application/pdf"
                style={{ display: "none" }}
                onChange={handleEmployeeResumeUpload}
              />
            </div>
          </div>
        </ModalNew>
        <ModalNew
          className="delete-modal"
          title={"Delete Resume"}
          visible={showDeleteResumeModal}
          onClose={() => {
            setShowDeleteResumeModal(false);
          }}
        >
          <div className="selector-container">
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignContent: "center",
              }}
            >
              <span
                style={{
                  fontSize: "16px",
                  color: "#000000",
                }}
              >
                Are you sure you want to delete this resume?
              </span>
            </div>

            <div style={{ display: "flex", gap: "10px", width: "100%", marginTop: "20px" }}>
              <CustomizeButton
                style={{
                  width: "50%",
                }}
                variant="primary"
                onClick={confirmDelete}
              >
                Confirm
              </CustomizeButton>

              <CustomizeButton
                style={{
                  width: "50%",
                }}
                variant="outlined"
                onClick={() => setShowDeleteResumeModal(false)}
              >
                Cancel
              </CustomizeButton>
            </div>
          </div>
        </ModalNew>

        <ToastContainer />
      </ContainerWrapper>
    </div>
  );
}

export default LayoutHOC(DashboardHr, { withSidebar: false, withNavbar: false });
